import React, { useCallback, useContext, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { MdArrowRight } from "react-icons/md";
import { StateContext, StatusContext } from "../../../../contexts";
import {
  Center,
  HStack,
  Heading,
  Image,
  Spinner,
  Text,
  VStack,
} from "native-base";
import { Helmet } from "react-helmet-async";
import colors from "../../../../constants/colors";
import API, { getFileUrl } from "../../../../api";
import routes from "../../../../routes";

function AgencyPaymentManagementServicesPage() {
  const params = useParams();
  const state = useContext(StateContext);
  const status = useContext(StatusContext);
  const [isLoading, setIsLoading] = useState(true);
  const [services, setServices] = useState([]);

  const getData = useCallback(async () => {
    try {
      setIsLoading(true);
      const {
        data: {
          data: { services: _services },
        },
      } = await API(state.jwt).get(`/tours/${params.id}`);
      setServices(_services);
    } catch (error) {
      status.updateErrorMessage(error);
    }
    setIsLoading(false);
  }, [params.id, state.jwt, status]);

  useEffect(() => {
    getData();
  }, [getData]);

  return (
    <VStack>
      <Helmet>
        <title>Ver servicios</title>
      </Helmet>
      <HStack paddingY={8} space={5}>
        <Link to={-1}>
          <Heading color={colors.secondary} fontSize="2xl">
            Gestión de cobros
          </Heading>
        </Link>
        <MdArrowRight color={colors.secondary} size={25} />
        <Heading color={colors.secondary} fontSize="2xl">
          Ver servicios
        </Heading>
      </HStack>
      {isLoading ? (
        <Center height={300}>
          <Spinner size="lg" color={colors.primary} />
        </Center>
      ) : (
        <HStack
          paddingX={6}
          paddingY={8}
          alignItems="flex-start"
          style={{ rowGap: 20, columnGap: 20, flexWrap: "wrap" }}>
          {services.map((service) => (
            <VStack
              key={service.id}
              shadow={1}
              borderRadius={10}
              padding={5}
              minWidth={300}
              alignItems="center">
              <HStack justifyContent="flex-end" width="full">
                <Link
                  to={routes.agencyPaymentManagementServicesService
                    .replace(":id", params.id)
                    .replace(":service", service.id)}>
                  <Text underline color={colors.primary}>
                    Ver detalles del viaje
                  </Text>
                </Link>
              </HStack>
              <Image
                src={getFileUrl(service.quotation.vehicleType.photos.at(0).url)}
                alt="vehicle"
                width={150}
                height={150}
              />
              <HStack justifyContent="space-between" width="full">
                <VStack alignItems="center">
                  <Text bold color={colors.secondary}>
                    Tipo de
                    <br />
                    unidad
                  </Text>
                  <Text>{service.quotation.vehicleType.name}</Text>
                </VStack>
                <VStack alignItems="center">
                  <Text bold color={colors.secondary}>
                    Asientos
                    <br />
                    disponibles
                  </Text>
                  <Text>
                    {service?.vehicle?.capacity ||
                      service?.quotation?.vehicleType?.capacity}
                  </Text>
                </VStack>
                <VStack alignItems="center">
                  <Text bold color={colors.secondary}>
                    Asientos
                    <br />
                    ocupados
                  </Text>
                  <Text>{service?.bookings?.length || 0}</Text>
                </VStack>
              </HStack>
            </VStack>
          ))}
        </HStack>
      )}
    </VStack>
  );
}

export default AgencyPaymentManagementServicesPage;
